import * as React from 'react';
import styled from 'styled-components'
import Paragraph from "../atom/text/paragraph";
import SubmitButtonWrapper from "../atom/wrapper/submit_btn_wrapper/submit_btn_wrapper";
import BtnLinkCorporateLarge from "../atom/btn/btn_link_corporate_large";


interface IProps {
    main: string;
    description: string;
    linkUrl?: string;
    btnText?: string;
}

const EmptyData: React.FC<IProps> = (props) => {

    const {main, description, linkUrl, btnText} = props;

    return (
        <Wrapper>
            <EmptyDataText>{main}</EmptyDataText>
            <EmptyDataText>{description}</EmptyDataText>
            {
                linkUrl &&
                    <SubmitButtonWrapper>
                        <BtnLinkCorporateLarge widthSize={"200px"} to={linkUrl}>{btnText}</BtnLinkCorporateLarge>
                    </SubmitButtonWrapper>
            }
        </Wrapper>
    );
};

export default EmptyData;

const Wrapper = styled.div`
    margin: 154px auto 154px auto;
    padding: 0;
    text-align: center;
    @media screen and (min-width: 768px) {
        margin: 254px auto 254px auto;
    }
`;


const EmptyDataText = styled(Paragraph)`
`;



// WEBPACK FOOTER //
// ./src/presentation/common/organism/empty_data.tsx